import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import { FaFilePdf } from "react-icons/fa";
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileAudio,
  FaFileVideo,
  FaFileCode,
  FaFileAlt,
} from "react-icons/fa";
import { BsLink45Deg, BsArrowRepeat } from "react-icons/bs";
import crossIcon from "../assets/icons/crossIcon.png";
import fileIcon from "../assets/icons/sboxfile.png";
import linkIcon from "../assets/icons/sboxlink.png";
import addIcon from "../assets/icons/add.png";
import editIcon from "../assets/Images/EditIcon1.png";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import { Modal, Button } from "react-bootstrap";
import "../css/Traindoc.css";
import "../css/extra.css";

const ICON_SIZE = 20; // 👈 consistent size for all icons

const getFileIcon = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();

  switch (ext) {
    case "pdf":
      return <FaFilePdf size={ICON_SIZE} className="text-danger me-2" />;
    case "doc":
    case "docx":
      return <FaFileWord size={ICON_SIZE} className="text-primary me-2" />;
    case "xls":
    case "xlsx":
      return <FaFileExcel size={ICON_SIZE} className="text-success me-2" />;
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
      return <FaFileImage size={ICON_SIZE} className="text-warning me-2" />;
    case "mp3":
    case "wav":
    case "flac":
      return <FaFileAudio size={ICON_SIZE} className="text-info me-2" />;
    case "mp4":
    case "avi":
    case "mov":
    case "mkv":
      return <FaFileVideo size={ICON_SIZE} className="text-secondary me-2" />;
    case "js":
    case "ts":
    case "jsx":
    case "tsx":
    case "json":
      return <FaFileCode size={ICON_SIZE} className="text-dark me-2" />;
    case "txt":
    case "csv":
      return <FaFileAlt size={ICON_SIZE} className="text-muted me-2" />;
    default:
      return <FaFileAlt size={ICON_SIZE} className="text-muted me-2" />;
  }
};

const TrainDocumentContent = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [urlLinks, setUrlLinks] = useState([""]);
  const [videoLinks, setVideoLinks] = useState([""]);
  const [uploadMode, setUploadMode] = useState("Global");
  const [showUploadModeDropdown, setShowUploadModeDropdown] = useState(false);
  const [description, setDescription] = useState("");
  const [dataName, setDataName] = useState("");
  const [isEditingDesc, setIsEditingDesc] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [summaryDataList, setSummaryDataList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);

  const fileInputRef = useRef();
  const navigate = useNavigate();

  const dropdownRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUploadModeDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles((prev) => [...prev, ...files]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFileUpload({ target: { files: e.dataTransfer.files } });
  };

  const handleDragOver = (e) => e.preventDefault();

  const removeUploadedFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const updateUrl = (index, value) => {
    const updated = [...urlLinks];
    updated[index] = value;
    setUrlLinks(updated);
  };

  const addUrlField = () => setUrlLinks([...urlLinks, ""]);
  const removeUrlField = (index) =>
    setUrlLinks(urlLinks.filter((_, i) => i !== index));

  const updateVideo = (index, value) => {
    const updated = [...videoLinks];
    updated[index] = value;
    setVideoLinks(updated);
  };

  const addVideoField = () => setVideoLinks([...videoLinks, ""]);
  const removeVideoField = (index) =>
    setVideoLinks(videoLinks.filter((_, i) => i !== index));

  const fetchSummaryFromBackend = async (uploadIds) => {
    try {
      const idsQuery = uploadIds.join(","); // These are python_file_uuid values
      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/summary?ids=${idsQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // console.log("Fetched summaries:", res.data);
      setSummaryDataList(res.data);
      // console.log(res.data);
      setShowSummaryModal(true);
    } catch (err) {
      console.error("Failed to fetch summaries:", err);
      showErrorToast("Failed to fetch summaries.");
    }
  };

  const regenerateSummary = async (fileId, index) => {
    try {
      setLoadingIndex(index); // 🚫 disable button for this index

      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/regenerate-summary`,
        { file_id: fileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newSummary = res.data.summary;

      setSummaryDataList((prevList) => {
        const updatedList = [...prevList];
        updatedList[index] = {
          ...updatedList[index],
          summary: newSummary,
        };
        return updatedList;
      });

      showSuccessToast("Summary regenerated!");
    } catch (err) {
      console.error("Failed to regenerate summary:", err);
      showErrorToast("Regeneration failed.");
    } finally {
      setLoadingIndex(null); // ✅ re-enable button
    }
  };

  const uploadToBackend = async () => {
    try {
      setIsUploading(true);
      setIsSubmitting(true);

      const formData = new FormData();

      uploadedFiles.forEach((file) => formData.append("files", file));
      urlLinks.forEach((url) => url.trim() && formData.append("urls", url));
      videoLinks.forEach(
        (yt) => yt.trim() && formData.append("youtube_urls", yt)
      );

      const mode =
        uploadMode === "Global" ? "pending_global" : uploadMode.toLowerCase();

      formData.append("upload_mode", mode);
      formData.append("file_description", description);
      formData.append("file_data_name", dataName);

      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          },
        }
      );

      // console.log("Upload response:", res.data);

      const uploadedItems = res.data.uploaded_files || [];
      // console.log("Uploaded items:", uploadedItems);

      // ✅ Extract python_file_uuid directly
      const uploadIds = uploadedItems.map((item) => item.python_file_uuid);
      // console.log("Upload IDs:", uploadIds);

      if (uploadIds.length > 0) {
        await fetchSummaryFromBackend(uploadIds); // Send python_file_uuid list
      }

      setUploadedFiles([]);
      setUrlLinks([""]);
      setVideoLinks([""]);
      setDescription("");
      setDataName("");
      setIsEditingDesc(false); // ✅ reset editing state
      setShowUploadModeDropdown(false); // ✅ close dropdown
      showSuccessToast(TOAST_MESSAGES.UPLOAD.SUCCESS);

      if (uploadMode === "Personal" || uploadMode === "Incognito") {
        navigate("/user/chat/document");
      }
    } catch (err) {
      console.error("Upload failed:", err);
      showErrorToast(TOAST_MESSAGES.UPLOAD.FAILED);
    } finally {
      setIsUploading(false);
      setIsSubmitting(false);
      setUploadProgress(0);
    }
  };

  return (
    <div className="container-fluid px-4 position-relative train-container">
      {/* Uploading Overlay */}
      {isUploading && (
        <div
          className="position-fixed upload-box top-10 end-0 p-3"
          style={{ zIndex: 2000, width: "320px" }}
        >
          <div className=" border  rounded-3 shadow-lg p-3 d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-2">
              <div
                className="spinner-border "
                style={{ width: "1.5rem", height: "1.5rem" }}
              ></div>
              <h6 className="mb-0 ">Uploading your file...</h6>
            </div>

            <div
              className="progress position-relative"
              style={{ height: "8px", overflow: "hidden", borderRadius: "4px" }}
            >
              <div
                className="progress-bar  progress-bar-striped progress-bar-animated"
                style={{
                  width: "100%",
                  animation: "uploadFlow 2s linear infinite",
                }}
              ></div>
            </div>

            <div className=" small text-end">Please wait…</div>
          </div>
        </div>
      )}

      <div className="row">
        {/* Left Section */}
        <div className="col-lg-9 col-12 mb-4">
          <h5 className="fw-semibold refresh-prompts mb-4">Train Document</h5>

          <div className="row">
            {/* Data Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Data Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Data Name"
                value={dataName}
                onChange={(e) => setDataName(e.target.value)}
                disabled={isUploading}
                style={{
                  pointerEvents: isUploading ? "none" : "auto", // 👈 add this
                  opacity: isUploading ? 0.5 : 1, // 👈 blur look
                }}
              />
            </div>

            {/* Upload Mode */}
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Upload Mode</label>
              <div className="dropdown" ref={dropdownRef}>
                <button
                  type="button"
                  onClick={() =>
                    !isUploading &&
                    setShowUploadModeDropdown(!showUploadModeDropdown)
                  }
                  disabled={isUploading}
                  className="form-control"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    height: "38px",
                    padding: "6px 12px",
                    backgroundColor: "var(--input-bg-color)",
                    color: "var(--input-text-color)",
                    border: "1px solid var(--input-border-color)", // ✅ FIX
                    borderRadius: "0.375rem",
                    cursor: "pointer",
                    fontSize: "1rem",
                    pointerEvents: isUploading ? "none" : "auto", // 👈 add this
                    opacity: isUploading ? 0.5 : 1, // 👈 blur look
                  }}
                >
                  <span>{uploadMode}</span>
                  <i
                    className={`bi ${
                      showUploadModeDropdown
                        ? "bi-chevron-up"
                        : "bi-chevron-down"
                    }`}
                    style={{
                      fontSize: "1rem",
                      // color: "var(--input-icon-color)",
                    }}
                  ></i>
                </button>

                {showUploadModeDropdown && (
                  <div className="dropdown-menu show w-25 shadow-sm custom-dropdown">
                    {["Global", "Personal", "Incognito"].map((mode) => (
                      <label
                        key={mode}
                        className="form-check custom-form-check d-flex align-items-center"
                        style={{ cursor: "pointer", width: "100%" }}
                        onClick={() => {
                          setUploadMode(mode);
                          setShowUploadModeDropdown(false);
                        }}
                      >
                        <input
                          className="custom-radio"
                          type="radio"
                          name="uploadMode"
                          id={mode}
                          value={mode}
                          checked={uploadMode === mode}
                          onChange={() => {}} // ✅ empty since onClick handles it
                        />
                        <span className="form-check-label custom-label ms-2">
                          {mode}
                        </span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="mb-4">
            <label className="form-label fw-semibold">Description</label>
            <div className="position-relative">
              {isEditingDesc ? (
                <textarea
                  className="input-textarea1 p-3"
                  rows="2"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onBlur={() => setIsEditingDesc(false)}
                  autoFocus
                  disabled={isUploading}
                />
              ) : (
                <div
                  className="input-textarea1 p-3  d-flex align-items-center"
                  style={{
                    minHeight: "70px",
                    cursor: isUploading ? "not-allowed" : "text", // 👈 disable cursor
                    pointerEvents: isUploading ? "none" : "auto", // 👈 block clicks
                    opacity: isUploading ? 0.5 : 1, // 👈 dim it
                  }}
                  onClick={() => !isUploading && setIsEditingDesc(true)} // 👈 click anywhere triggers edit
                >
                  <span className="flex-grow-1">
                    {description || "No description added."}
                  </span>
                  {!isUploading && (
                    <img
                      src={editIcon}
                      alt="Edit"
                      className="icon-image ms-2"
                      style={{
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setIsEditingDesc(true)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Drag and Drop Upload */}
          <div
            className=" border-2  text-center p-3 mb-4 rounded"
            onDrop={!isUploading ? handleDrop : undefined}
            onDragOver={!isUploading ? handleDragOver : undefined}
            style={{
              borderStyle: "dashed",
              border: "dashed var(--input-border-color)",
              pointerEvents: isUploading ? "none" : "auto", // 👈 disable interactions
              opacity: isUploading ? 0.5 : 1, // 👈 dim look
            }}
          >
            <input
              type="file"
              multiple
              ref={fileInputRef}
              onChange={handleFileUpload}
              accept=".pdf,.doc,.docx,.txt,.csv,.xls,.xlsx,.mp3,.wav,.flac,.mp4,.avi,.mov,.mkv"
              className="d-none"
            />
            <div>
              <i className="bi bi-cloud-arrow-up fs-1 text-secondary" />
            </div>
            <p className=" refresh-prompts fw-semibold mb-1">
              Drag & Drop File
            </p>
            <p className=" refresh-prompts small">
              Supports .pdf, .doc, .txt, .mp3, .mp4
            </p>
            <button
              type="button"
              className="custom-btn px-4"
              onClick={(e) => {
                if (!isUploading) fileInputRef.current.click();
                e.currentTarget.blur(); // 👈 blur the button itself
              }}
              disabled={isUploading}
            >
              Upload
            </button>
          </div>

          {/* URL Upload */}
          <div className="mb-4">
            <label className="refresh-prompts fw-semibold">
              Or Upload from URL
            </label>
            {urlLinks.map((url, i) => (
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  value={url}
                  onChange={(e) => updateUrl(i, e.target.value)}
                  disabled={isUploading}
                  style={{
                    pointerEvents: isUploading ? "none" : "auto", // 👈 add this
                    opacity: isUploading ? 0.5 : 1, // 👈 blur look
                  }}
                />
                {i > 0 && (
                  <span
                    className="input-group-text"
                    style={{
                      cursor: isUploading ? "not-allowed" : "pointer",
                      pointerEvents: isUploading ? "none" : "auto",
                      opacity: isUploading ? 0.5 : 1,
                    }}
                  >
                    <img
                      src={crossIcon}
                      alt="Remove"
                      style={{ width: "16px", height: "16px" }}
                      onClick={() => removeUrlField(i)}
                      className="icon-image"
                    />
                  </span>
                )}
              </div>
            ))}
            <div
              className="d-flex align-items-center text-[#3E3E3E] mt-1"
              role="button"
              onClick={!isUploading ? addUrlField : undefined}
              style={{
                pointerEvents: isUploading ? "none" : "auto",
                opacity: isUploading ? 0.5 : 1,
              }}
            >
              {/* <FaPlusCircle className="me-2" /> */}
              <img
                src={addIcon}
                alt="Add"
                style={{ width: "16px", height: "16px" }}
                className="me-2 icon-image"
              />
              <span className="refresh-prompts">Add More</span>
            </div>
          </div>

          {/* Video Upload */}
          <div className="mb-4">
            <label className="form-label refresh-prompts fw-semibold">
              Or Upload from Video
            </label>
            {videoLinks.map((url, i) => (
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  value={url}
                  onChange={(e) => updateVideo(i, e.target.value)}
                  disabled={isUploading}
                  style={{
                    pointerEvents: isUploading ? "none" : "auto", // 👈 add this
                    opacity: isUploading ? 0.5 : 1, // 👈 blur look
                  }}
                />
                {i > 0 && (
                  <span
                    className="input-group-text"
                    style={{
                      cursor: isUploading ? "not-allowed" : "pointer",
                      pointerEvents: isUploading ? "none" : "auto",
                      opacity: isUploading ? 0.5 : 1,
                    }}
                  >
                    <img
                      src={crossIcon}
                      alt="Remove"
                      style={{ width: "16px", height: "16px" }}
                      onClick={() => removeVideoField(i)}
                      className="icon-image"
                    />
                  </span>
                )}
              </div>
            ))}

            <div
              className="d-flex align-items-center text-[#3E3E3E] mt-1"
              role="button"
              onClick={!isUploading ? addVideoField : undefined}
              style={{
                pointerEvents: isUploading ? "none" : "auto",
                opacity: isUploading ? 0.5 : 1,
              }}
            >
              {/* <FaPlusCircle className="me-2" /> */}
              <img
                src={addIcon}
                alt="Add"
                style={{ width: "16px", height: "16px" }}
                className="me-2 icon-image"
              />
              <span className="refresh-prompts">Add More</span>
            </div>
          </div>

          {/* Submit */}
          <div className="text-end submit-btn">
            <button
              type="button"
              className="custom-btn px-5"
              onClick={uploadToBackend}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>

        {/* Right Section - Uploaded Files */}
        <div className="col-lg-3 col-12">
          <div className="card home-card p-3 shadow-sm min-h-100">
            <span className="refresh-promts mb-3">Uploaded Files</span>
            {uploadedFiles.length === 0 ? (
              <div className="refresh-promts">No files uploaded.</div>
            ) : (
              <>
                {uploadedFiles.map((file, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-center justify-content-between uploaded-docs p-2 rounded mb-2"
                  >
                    {/* <div className="d-flex align-items-center overflow-hidden">
                      {getFileIcon(file.name)}
                      <span className="text-truncate">{file.name}</span>
                    </div> */}
                    <div className="d-flex align-items-center overflow-hidden">
                      {getFileIcon(file.name)}
                      <span className="text-truncate">{file.name}</span>
                    </div>

                    <button
                      className="btn btn-sm p-1"
                      onClick={() => !isUploading && removeUploadedFile(i)}
                      disabled={isUploading}
                    >
                      <img
                        src={crossIcon}
                        alt="Remove"
                        style={{ width: "16px", height: "16px" }}
                        onClick={() => removeVideoField(i)}
                        className="icon-image"
                      />
                    </button>
                  </div>
                ))}
                <div className="progress mt-2" style={{ height: "5px" }}>
                  <div className="progress-bar" style={{ width: "100%" }}></div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {showSummaryModal && summaryDataList && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header justify-content-center position-relative">
                <h5 className="modal-title m-0">
                  Summaries from uploaded Documents and URL
                </h5>
                <button
                  type="button"
                  className="modal-close-btn"
                  onClick={() => setShowSummaryModal(false)}
                  aria-label="Close"
                >
                  <img
                    src={crossIcon}
                    className="icon-image cross-i"
                    alt="Close"
                  />
                </button>
              </div>

              <div className="modal-body">
                {summaryDataList.length === 0 ? (
                  <p>No summaries available.</p>
                ) : (
                  summaryDataList.map((summary, index) => (
                    <div key={index} className="rounded-3 p-3 mb-3">
                      <div className="mb-2 d-flex align-items-center gap-3">
                        {summary.type === "file" ? (
                          <img
                            src={fileIcon}
                            alt="file"
                            className="icon-image"
                            style={{ width: "20px", height: "20px" }}
                          />
                        ) : (
                          <img
                            src={linkIcon}
                            alt="link"
                            style={{ width: "20px", height: "20px" }}
                          />
                        )}
                        <div>
                          <div
                            className="refresh-prompts summary-text"
                            title={summary.name}
                          >
                            {summary.name || "Untitled"}
                          </div>
                          <div
                            className="small refresh-prompts summary-link"
                            title={summary.link}
                          >
                            {summary.link || ""}
                          </div>
                        </div>
                      </div>

                      <div className="position-relative">
                        <textarea
                          style={{ fontSize: "14px" }}
                          className="form-control"
                          rows={5}
                          value={summary.summary || "No summary available."}
                          readOnly
                        />
                        <button
                          className="btn btn-link position-absolute text-white end-0 mt-1 bg-dark me-2"
                          onClick={() =>
                            regenerateSummary(
                              summary?.approval_request_id,
                              index
                            )
                          }
                          disabled={loadingIndex === index} // 🚫 prevent double click
                        >
                          {loadingIndex === index ? (
                            <span className="spinner-border spinner-border-sm text-light" />
                          ) : (
                            <BsArrowRepeat size={18} />
                          )}
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="cancle-btn px-3"
                  onClick={() => setShowSummaryModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainDocumentContent;
